import { Card, Flex, Tag } from 'antd';
import React, { useEffect, useState } from 'react';
import CustomCard from 'components/shared-components/Card/custom_card';
import { ClockCircleOutlined } from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
/* import all the icons in Free Solid, Free Regular, and Brands styles */
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { useTranslation } from 'react-i18next';

library.add(fas, far, fab);

const data = [
    // {
    //     id: 123,
    //     content: 'Phiếu nhập kho #NK-2847 được duyệt',
    //     createDate: '2026-08-11 17:00:00',
    //     timeConversion: '5 phút trước',
    //     icon: 'fa-regular fa-clock',
    //     employee_name: 'Nguyễn Văn A',
    //     module: 'Quản lý kho',
    //     color: '#10b98199'
    // },{
    //     id: 234,
    //     content: 'Hệ thống sao lưu dữ liệu thành công',
    //     createDate: '2026-08-10 00:00:00',
    //     timeConversion: '1 ngày trước',
    //     icon: 'fa-solid fa-shield',
    //     employee_name: 'ERP Bot',
    //     module: 'Quản trị hệ thống',
    //     color: '#a855f7'
    // },
]

const Activity = (props) => {

    const { t } = useTranslation(['home']);
    const [activity, setActivity] = useState([]);
    useEffect(() => {
        setActivity(data);
    }, [])

    return (
        <div style={{ height: '100%' }}>
            <CustomCard
                title={<span><ClockCircleOutlined /> {t(`operation_log`, 'Nhật ký thao tác')}</span>}
                style={{ height: '100%', marginTop: 0 }}
            >
                <Flex className="w-100" justify="flex-start" align="center" vertical gap={16}>
                    {activity.map((e) => (
                        <Flex className="w-100" flex={1} key={e.id} justify="center" align="center" gap={6}>
                            <div className="mr-2">
                                <FontAwesomeIcon color={e.color} icon={e.icon ?? 'fa-regular fa-clock'} />
                            </div>
                            <div style={{ flex: 1 }}>
                                <div className="font-size-base text-foreground leading-snug">{e.content}</div>
                                <Tag>{e.employee_name}</Tag>
                                <span className="mr-1">- </span>
                                <Tag>{e.module}</Tag>
                            </div>
                            <div>
                                <div className="font-size-sm text-muted-foreground mt-0.5">{e.timeConversion}</div>
                            </div>
                        </Flex>
                    ))}
                </Flex>
            </CustomCard>
        </div>
    );
}

export default Activity;